import { Component } from '@angular/core';

import { fuseAnimations } from '@fuse/animations';

///IDIOMAS
import { lang_requerimientos } from 'app/idiomas/i18n/requerimientos/requerimientos.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

import { RequirementsService } from "../services/requirements.service";
import * as backInter from 'app/auth/auth-data.model';
import Swal from 'sweetalert2';
import {TranslateService} from '@ngx-translate/core';
import { ReqStepperService } from "app/main/pagina/tools/req-stepper/req-stepper.service";
import { ActivatedRoute } from '@angular/router';
@Component({
    selector   : 'detail-requirements',
    templateUrl: './detailrequirements.component.html',
    styleUrls  : ['./detailrequirements.component.scss'],
    animations : fuseAnimations
})
export class DetailRequirementsComponent
{
    bandera : boolean = false;
    porcentajeAvance:number;
    muestraPorcentaje:boolean;
    idInstituto: string;
    tipoProductoNorma=false;
    origen: any; 

    constructor(
        private service : RequirementsService,
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private translateSrv: TranslateService,
        private reqService: ReqStepperService,
        private activatedRoute:ActivatedRoute,
    )
    {
        lang_requerimientos.forEach((locale) => {
            this._fuseTranslationLoaderService.loadTranslations(locale);
        });
        this.idInstituto = this.reqService.getInstituto();

        this.velidateBanderas();
        console.log(this.idInstituto);

        if(this.idInstituto == "1" || this.idInstituto == 'MX'){
          this.calculaAvance();
        }
        else{
          this.porcentajeAvance = 100;
        }



        this.activatedRoute.data.subscribe(params => {
          this.origen = params;
          console.log('this.origen',this.origen);
        if (this.origen.producto=='Norma') {
          this.tipoProductoNorma=true;
        }


        });
    }

    calculaAvance(){
      this.muestraPorcentaje = true;
      let suma = 0;
      this.reqService.getInfoReqTecUser().subscribe((respuesta:backInter.getInfoReqTec) => {
        console.log(respuesta);
        if(respuesta.pasos.length > 0){
          respuesta.pasos.forEach((paso:any, i) => {
            if(paso.status == 2){
              suma++;
            }
          });
          this.porcentajeAvance = ((suma / respuesta.pasos.length) * 100);
        }
        else this.porcentajeAvance = 100;
      });
    }

    velidateBanderas(){
       let productoId=localStorage.getItem('productoID');
       let company = this.service.bandera_getCompanyID();
      if(localStorage.getItem('productoID') && company != "0"){
        console.log("Entro velidate bandera");
        let data = {
          // fechaCertificar: localStorage.getItem('fechaProducto')
          productoId: localStorage.getItem('productoID')
        }
        this.service.getBanderas(data).subscribe((response:backInter.statusReqTec) => {
          console.log(response);
          if(response.success){
              if(response.requerimientos){
                this.bandera = true;
              }else{
                //Swal.fire(this.translateSrv.instant('SHEDULE.ACEPTARREQUERIMIENTOS'));
              }
          }
        }, error => {
          console.log(error);
        });
      }else{
        this.bandera = true;
      }
    }

    setBandera(){
      if(localStorage.getItem('tipoproductoID')=='Focus'){
        if(this.porcentajeAvance == 100){
           let data = {
             // fechaCertificar: localStorage.getItem('fechaProducto')
             encuestaId: localStorage.getItem('encuestaID')
           }
           this.service.setBanderaFocus(data).subscribe((response:backInter.RespuestaGen) => {

             console.log(response);
             if(response.success){
               this.bandera = true;
               let rspOk = 'REQUERIMIENTOS.MENSAJES.OK';
               this.translateSrv.get(rspOk).subscribe((res: string) => { rspOk = res; });
               Swal.fire({
                 icon: 'success',
                 title: this.translateSrv.instant('REQUERIMIENTOS.MENSAJES.CONFREQ'),
                 
                 confirmButtonText: rspOk,
               });
             }

           }, error => {
             console.log(error);
           });
         }
         else{
           let rspOk = 'REQUERIMIENTOS.MENSAJES.OK';
           this.translateSrv.get(rspOk).subscribe((res: string) => { rspOk = res; });
           Swal.fire({
             icon: 'warning',
             title: this.translateSrv.instant('REQUERIMIENTOS.VALIDACION.MENSAJES.AUNNO'),
             
             confirmButtonText: rspOk,
           });
         }


      }else{

        if(this.porcentajeAvance == 100){
          let data = {
            // fechaCertificar: localStorage.getItem('fechaProducto')
            productoId: localStorage.getItem('productoID')
          }
          this.service.setBandera(data).subscribe((response:backInter.RespuestaGen) => {

            console.log(response);
            if(response.success){
              this.bandera = true;
              let rspOk = 'REQUERIMIENTOS.MENSAJES.OK';
              this.translateSrv.get(rspOk).subscribe((res: string) => { rspOk = res; });
              Swal.fire({
                icon: 'success',
                title: this.translateSrv.instant('REQUERIMIENTOS.MENSAJES.CONFREQ'),
                
                confirmButtonText: rspOk,
              });
            }

          }, error => {
            console.log(error);
          });
        }
        else{
          let rspOk = 'REQUERIMIENTOS.MENSAJES.OK';
          this.translateSrv.get(rspOk).subscribe((res: string) => { rspOk = res; });
          Swal.fire({
            icon: 'warning',
            title: this.translateSrv.instant('REQUERIMIENTOS.VALIDACION.MENSAJES.AUNNO'),
            
            confirmButtonText: rspOk,
          });
        }
      }




    }
}
